<template>
  <el-dialog
    :title="version==='trial'? '获取商业试用版': '获取商业版'"
    :visible.sync="visible"
    width="800px"
    :before-close="close">
    <p>尊敬的用户：</p>
    <p v-if="version==='business'" style="text-indent: 2em;">您好！感谢您对我们的产品感兴趣。若需体验完整功能的商业版产品，请您将您的姓名和联系方式发送至我们的官方邮箱<span ref="email" class="email" @click="handleEmailClick">business@n6delta.com</span>。我们的客服团队将在三个工作日内与您取得联系，为您提供进一步的服务和支持。再次感谢您对我们产品的关注与支持，期待与您建立长期的合作关系！</p>
    <p v-else-if="version==='trial'" style="text-indent: 2em;">您好！感谢您对我们的产品感兴趣。若需体验完整功能的商业试用版产品，请您将您的姓名和联系方式发送至我们的官方邮箱<span ref="email" class="email" @click="handleEmailClick">business@n6delta.com</span>。我们的客服团队将在三个工作日内与您取得联系，为您提供进一步的服务和支持。再次感谢您对我们产品的关注与支持，期待与您建立长期的合作关系！</p>
    <p style="text-indent: 2em;">此致</p>
    <p>敬礼！</p>
    <p style="text-align: right;">杭州矩尺网络科技有限公司</p>
    <span slot="footer" class="dialog-footer">
      <el-button @click="close">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { Message } from 'element-ui'

export default {
  props: {
    visible: {
      type: Boolean,
      default:false
    },
    version: {
      type: String,
      default: 'business'
    }
  },
  methods: {
    close() {
      this.$emit('update:visible', false)
    },
    handleEmailClick() {
      // 复制内容到剪贴板
      const email = this.$refs.email.innerText
      navigator.clipboard.writeText(email).then(() => {
        Message.success({
          message: '邮箱已复制',
          type: 'success'
        })
      }).catch(err => {
        console.error('Failed to copy: ', err)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
::v-deep .el-dialog{
  .el-dialog__body{
    padding: 2em 4em;
    font-size: 16px;
    text-align: left;
  }
  .el-dialog__footer{
    text-align: center;
  }
}
.email{
  cursor: copy;
  color: $primaryColor;
}
</style>